// assets
import {
  DashboardOutlined,
  LoginOutlined,
  TeamOutlined,
  UserOutlined,
  ProjectOutlined,
  BugOutlined,
  FileTextOutlined,
  CreditCardOutlined,
  ApartmentOutlined,
  SettingOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  LoginOutlined,
  TeamOutlined,
  UserOutlined,
  ProjectOutlined,
  BugOutlined,
  FileTextOutlined,
  CreditCardOutlined,
  ApartmentOutlined,
  SettingOutlined
};

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    {
      id: 'group-main',
      title: 'Navigation',
      type: 'group',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/dashboard/default',
          icon: icons.DashboardOutlined,
          breadcrumbs: false
        },
        {
          id: 'accounts',
          title: 'Accounts',
          type: 'item',
          url: '/accounts',
          icon: icons.TeamOutlined
        },
        {
          id: 'tenants',
          title: 'Tenants',
          type: 'item',
          url: '/tenants',
          icon: icons.ApartmentOutlined
        },
        {
          id: 'users',
          title: 'Users',
          type: 'item',
          url: '/users',
          icon: icons.UserOutlined
        },
        {
          id: 'projects',
          title: 'Projects',
          type: 'item',
          url: '/projects',
          icon: icons.ProjectOutlined
        },
        {
          id: 'divider-1',
          type: 'divider'
        },
        {
          id: 'CMS',
          title: 'CMS',
          type: 'item',
          url: '/cms',
          icon: icons.FileTextOutlined
        },
        {
          id: 'settings',
          title: 'Settings',
          type: 'item',
          url: '/settings',
          icon: icons.SettingOutlined
        }
      ]
    }
  ]
};

export default menuItems;
